export const STORAGE_NAME = 'requestSniffer';

export const EVENT_ADDED_XHR_RECORD = 'added-xhr-record';

export const PAGES_REF_ID = 'page';
